var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 132,
    viewBox: "0 0 154 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M31.3415 12.127C28.6656 12.4615 23.6502 18.3447 22.0318 20.3228C17.1155 26.3316 14.0214 33.0972 10.4145 39.8971C0.303427 58.959 4.58388 78.7119 13.0801 97.6651C16.6517 105.632 24.9683 111.662 32.0974 116.245C47.639 126.236 67.8453 126.98 85.688 127.265C102.947 127.541 118.511 125.693 133.032 115.966C143.117 109.211 146.309 94.8677 148.628 83.6607C150.696 73.6655 148.496 66.3729 143.416 57.681C140.428 52.5678 137.167 46.2935 133.311 41.767C119.058 25.0354 98.679 9.97746 76.7761 5.28399C65.0901 2.77983 53.7297 6.95669 42.3222 8.14852C36.4581 8.76119 28.5064 7.6192 23.5038 11.3711C20.5272 13.6036 18.1418 15.6976 15.5866 18.5722",
    stroke: "black",
    strokeWidth: 7.62455,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M39.2191 52.2304C35.259 52.2304 36.4967 64.4596 41.3675 58.6756C42.8357 56.932 45.2677 53.6333 46.2212 51.5143C47.5161 48.6367 43.0188 47.4954 42.0836 49.3659",
    stroke: "black",
    strokeWidth: 7.62455,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M91.4965 45.7853C92.9085 50.4133 94.2042 54.1815 99.5331 54.3788C103.265 54.5171 102.239 52.4262 102.239 49.0874C102.239 46.4425 100.127 46.1224 97.9019 45.4272C94.5908 44.3925 91.4679 47.9623 89.3481 50.082",
    stroke: "black",
    strokeWidth: 7.62455,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M44.5171 101.935C44.5171 93.2391 50.5328 85.2156 58.2827 81.7239C64.142 79.084 71.7046 76.182 78.2549 76.9099C92.1932 78.4586 97.5066 96.195 101.808 106.948",
    stroke: "black",
    strokeWidth: 7.62455,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.e9d06132a153c83bae83459406e7e840.svg";
export { ForwardRef as ReactComponent };